import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  buttonMobile: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  buttonInnerMobile: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
  },
  buttonDesktop: {
    minWidth: 166,
  },
  buttonInnerDesktop: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  buttonSelected: {
    backgroundColor: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkBgPressed,
  },
  text: { fontWeight: 400, fontSize: 18 },
  textMobile: { fontWeight: 700, fontSize: 12 },
});
